export default {
  hzmbG: {
    title: {
      hzmbG: "Estacionamento de automóveis \nde mercadorias de Hong Kong no Posto de Transferência de Mercadorias Transfronteiriço de Macau",
      application: 'Informações do requerimento',
      vehicle: 'Informações do veículo',
      owner: 'Informações do proprietário do veículo',
      drivers: 'Informações de condutor',
      driversIndex: '{0}.º condutor',
      cancelDescription: 'Cancelar a descrição',
      auth: 'Verificação de identificação',
    },
    label: {
      registrationNo: "N.º do registo do veículo de Hong Kong",
      identificationNo: "N.º do quadro do veículo",
      mobile: "N.º de telemóvel do proprietário do veículo (para notificação por SMS)",
      mobileAreaCode: "Código de zona",
      mobiltTips: "O n.º de consulta será enviado por SMS de telemóvel e e-mail. Confirme a respectiva informação.",
      validType: "Tipo de autenticação",
      approveNo: "N.º da autorização de Macau",
      identificationNoLast4: "Os últimos 4 dígitos do quadro do veícuo",
      registerType: "Tipo de registo",
      identType: "Tipo do documento de identificação",
      identNo: "N.º do documento de identificação",
      companyRegistrationType: "Tipo do certificado de registo da sociedade",
      companyRegistrationNo: "N.º do certificado de registo da sociedade",
      mainlandRegistrationNo: "N.º do registo do veículo do Interior da China",
      registrationType: "Tipo do registo de veículo de Hong Kong",
      factory: "Nome da fábrica",
      modelType: "Modelo",
      buildYear: "Ano de fabricação",
      firstRegisterDate: "Data do registo inicial",
      color: "Cor",
      driverSeat: "Posição do lugar do condutor",
      passengerCount: "N.º de lotação (com excepção dos motoristas)",
      engineNo: "N.º do motor",
      permitWeight: "Peso bruto do veículo autorizado",
      licenseExpireDate: "Data do termo da licença de veículo de Hong Kong",
      mainlandInsuranceNo: "N.º da apólice de seguro do Interior da China",
      mainlandInsuranceStartDate: "Data de vigência da apólice de seguro do Interior da China",
      mainlandInsuranceEndDate: "Data do termo da apólice do Interior da China",
      ownerNameEn: "Nome em inglês do proprietário de veículo",
      identityType: "Tipo do documento de identificação",
      identityNo: "N.º do documento de identificação",
      address: "Endereço",
      ownerCompanyNameEn: "Denominação social em inglês",
      companyIdentityType: "Tipo do certificado de registo da sociedade",
      companyRegisterNo: "N.º do certificado de registo da sociedade",
      companyAddress: "Endereço da sociedade",
      macauMobile: "N.º de telefone",
      email: "Endereço de correio electrónico",
      driverNameEn: "Nome em inglês",
      hongKongDrivingLicenseType: "Tipo de carta de condução de Hong Kong (tipo de veículos autorizados para conduzir)",
      hongKongDrivingLicenseNo: "N.º da carta de condução de Hong Kong",
      birthday: "Data de nascimento",
      sex: "Sexo",
      nationality: "Nacionalidade",
      cancelReason: "Motivo do cancelamento",
      mainlandDrivingFileNo: "Número do processo de permissão de condução do Interior da China",
      mainlandDrivingLicenseNo: "Número da carta de condução do Interior da China",
      personal: "Individual",
      company: "Sociedade/ Unidade"
    },
    message: {
      registrationNo: 'Introduza o n.º do registo do veículo de Hong Kong',
      identificationNo: 'Introduza o n.º do quadro do veículo',
      mobile:
        'Introduza o n.º de telemóvel do proprietário do veículo (para notificação por SMS)',
      vcode: 'Faça a verificação de segurança',
      approveNo: 'Introduza o n.º de aprovação de Macau',
      identificationNoLast4:
        'Introduza os últimos 4 dígitos do quadro do veículo',
      registerType: 'Introduza o tipo de registo',
      identNo: 'Introduza o n.º do documento de identificação',
      companyRegistrationNo:
        'Introduza o n.º do certificado de registo da sociedade',
      mainlandRegistrationNo:
        'Introduza o n.º do registo do veículo do Interior da China',
      registrationType:
        'Introduza a categoria do registo do veículo de Hong Kong',
      factory: 'Introduza o nome da fábrica',
      modelType: 'Introduza o modelo',
      buildYear: 'Introduza o ano de fabricação',
      firstRegisterDate: 'Introduza a data do registo inicial',
      color: 'Introduza a cor',
      driverSeat: 'Posição do lugar do condutor',
      engineNo: 'Introduza o n.º do motor {0}',
      permitWeightTable: {
        title:
          'De acordo com a legislação vigente de Macau, são as seguintes restrições quanto ao peso bruto de veículos:',
        type: 'Tipo de veículo',
        weight: 'Limite de peso bruto',
        two: 'Dois eixos',
        three: 'Três eixos',
        four: 'Quatro eixos',
        fiveOrMore: 'Cinco ou mais eixos',
        type1: 'Só veículos',
        type2: 'Combinação de tractor e semi-reboque',
        type3: 'Combinação de veículos e reboques',
      },
      vehicleType: 'Tipo de veículo',
      vehicleType1: 'Só veículos',
      vehicleType2: 'Combinação de tractor e semi-reboque',
      vehicleType3: 'Combinação de veículos e reboques',
      permitWeight: 'Insira o peso bruto do veículo autorizado',
      ton: 'Toneladas',
      permitWeightTip1: 'Limite de peso de 10 toneladas por eixo único',
      permitWeightTip2: 'Limite de peso de 16 toneladas por dois eixos',
      permitWeightTip3:
        'Limite de peso de 22 toneladas por 3 ou mais eixos',
      permitWeightFloat: 'Manter até uma casa decimal',
      permitWeightMax:
        'Introduza o peso bruto correto do veículo autorizado',
      licenseExpireDate:
        'Introduza a data de termo da licença do veículo de Hong Kong',
      vehicleSize: {
        title:
          'Nos termos da legislação vigente em Macau, as dimensões máximas da carroçaria de veículos são as seguintes:',
        max: 'Limite de tamanho máximo',
        length: 'Comprimento',
        weight: 'Largura',
        height: 'Altura (a partir do solo)',
      },
      mainlandInsuranceNo:
        'Introduza o n.º da apólice de seguro do Interior da China',
      mainlandInsuranceStartDate:
        'Introduza a data de vigência da apólice de seguro do Interior da China',
      mainlandInsuranceEndDate:
        'Introduza a data de termo da apólice de seguro do Interior da China',
      ownerNameEn: 'Introduza o nome em inglês do proprietário do veículo',
      nameEnChcek: 'Preencher apenas letras e caracteres',
      company_nameEnChcek: 'Preencher apenas letras, números e caracteres',
      identityNoCheck: "Preencher apenas letras e números",
      identityType: 'Introduza o tipo de documento de identificação',
      identityNo: 'Introduza o número do documento de identificação',
      address: 'Introduza o endereço',
      ownerCompanyNameEn: 'Introduza o nome da sociedade em inglês ',
      companyIdentityType:
        'Introduza o tipo de certificado de registo da sociedade',
      companyRegisterNo:
        'Introduza o número do certificado de registo da sociedade',
      companyAddress: 'Introduza o endereço da sociedade',
      macauMobile: 'Introduza o n.º de contacto',
      email: 'Introduza o endereço de correio electrónico',
      email_confirm:
        'Introduza novamente o endereço de correio electrónico ',
      emial_confirm_tip:
        'Confirma o endereço de correio electrónico introduzido',
      driverNameEn: "Introduza o nome em inglês",
      hongKongDrivingLicenseType: "Introduza o tipo de carta de condução de Hong Kong (tipo de veículos autorizados para conduzir)",
      hongKongDrivingLicenseNo: "Introduza o número da carta de condução de Hong Kong",
      hongKongDrivingLicenseNoCheck: "Só é permitido o preenchimento da letra romanizada, do número e da palavra “/”",
      birthday: "Introduza a data de nascimento",
      sex: "Introduza o sexo",
      nationality: "Introduza a nacionalidade",
      agreeVehicleSize: "Tenho conhecimento e comprometo a utilização dos automóveis de mercadorias de Hong Kong com menos das dimensões máximas do veículo no Posto de Transferência de Mercadorias Transfronteiriço de Macau.",
      checkTips: "O n.º de consulta será enviado por SMS de telemóvel e e-mail. Confirme a respectiva informação.",
      mainlandDrivingFileNo: "Introduza o n.º do documento de permissão de condução do Interior da China",
      mainlandDrivingLicenseNo: "Introduza o n.º da carta de condução do Interior da China",
      driversIdentityNo: "Se for condutor do Interior da China, introduza o número do Salvo-conduto para Deslocação a Hong Kong e Macau",
    },
    enum: {
      areas: {
        macau: 'Macau + 853',
        hongkong: 'Hong Kong + 852',
        mainland: "China +86"
      },
      registerType: {
        PERSON: 'Registo a título individual',
        COMPANY: 'Registo em nome de sociedade/ unidade',
      },
      driverSeat: {
        E: 'Volante à esquerda',
        D: 'Volante à direita',
      },
      hkVehicleRegisterType: {
        LIGHT_TRUCK: 'Automóvel ligeiro de mercadorias',
        MEDIUM_TRUCK: 'Automóvel médio de mercadorias',
        HEAVY_TRUCK: 'Automóvel pesado de mercadorias',
        TRACTOR: 'Tractor',
        TOW_TRUCK: 'Reboque',
      },
      cancelReasons: {
        PRIVATE_CANCEL_REASON: "Por motivo privado",
        COMPANY_CANCEL_REASON: "Por determinação da empresa",
        OTHER_CANCEL_REASON: "Outro motivo"
      }
    },
    success: {
      title: 'Tratamento sucedido',
      applicationNo: 'N.º do pedido:',
    },
    terms_hzmbG_first:"<p>" +
    "  1. Observações" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>Em cada requerimento podem ser designados, no máximo, três condutores que sejam titulares de carta de condução de veículos comerciais emitida pela autoridade de Hong Kong.</li>" +
    "  <li>Depois de obtida a autorização, a substituição do veículo registado (adiante designado por “veículo autorizado”) ou a alteração do número de matrícula do veículo está sujeita ao cancelamento do registo corrente e ao novo requerimento, apresentado à Direcção dos Serviços para os Assuntos de Tráfego por via de carta.</li>" +
    "  <li>A autorização é intransmissível e durante o prazo de validade da mesma, caso haja transmissão do título da propriedade do veículo (o titular da autorização deixa de ser o proprietário do veículo autorizado), a respectiva autorização será automaticamente cancelada.</li>" +
    "  <li>O veículo autorizado tem de ser automóvel ligeiro, médio ou pesado de mercadorias, tractor ou semi-reboque registado em Hong Kong, em nome da entidade particular/comercial titular da autorização, e deve cumprir os requisitos de peso bruto, comprimento e largura dos automóveis de mercadorias previstos no Regulamento do Trânsito Rodoviário de Macau, sendo a altura não superior a 4,6 metros; a entidade particular/comercial titular da autorização deve ainda garantir que o veículo autorizado seja munido do seguro obrigatório válido das três regiões aquando da circulação na Ponte Hong Kong-Zhuhai-Macau.</li>" +
    "  <li>O veículo autorizado e os condutores designados são obrigados a respeitar a legislação de Hong Kong e de Macau. A par disso, como a estrutura principal da ponte se situa em área sob domínio jurisdicional do Interior da China, é obrigatório cumprir a legislação do Interior da China assim como a regulação dos veículos que circulam entre Hong Kong e Macau mas não entram em Zhuhai.</li>" +
    "  <li>O veículo autorizado com “Closed Road Permit for Cross-boundary Vehicles” (CRP) emitida pelo Departamento de Transportes de Hong Kong, licença provisória de condução e licença provisória do veículo emitidas pelo Interior da China e seguros das três regiões, pode deslocar-se ao Posto de Transferência de Mercadorias Transfronteiriço de Macau através da Ponte Hong Kong-Zhuhai-Macau, estando conduzido por condutor designado, titular da carta de condução de veículos comerciais. Os indivíduos são responsáveis, por sua conta, pelo impedimento de circulação na Ponte em seu veículo autorizado, por motivos causados pelo próprio ou por decisão do Interior da China ou de Hong Kong.</li>" +
    "  <li>Se o titular da autorização, os condutores designados ou o veículo autorizado não respeitarem as normas de atribuição de autorização e de emissão de licenças de Hong Kong e Macau, as respectivas licenças e autorização poderão ser canceladas e o novo pedido de autorização e licenças não será aceite. O cancelamento da autorização e das licenças ou a desqualificação de entrada nas regiões poderá causar o sequente cancelamento das respectivas licenças e autorização.</li>" +
    "  <li>Se o veículo ou o requerente for desqualificado para entrar no Interior da China nos termos legais, as respectivas licenças e autorização poderão ser canceladas e o pedido para atribuição de novas licenças e autorização não será considerado.</li>" +
    "  <li>A autorização será cancelada em caso de descoberta de acções de contrabando, de tráfico humano, de transporte ilegal (veículo clandestino) ou de transporte de produtos objecto de proibição ou restrição de entrada e saída da região, bem como de não declaração das bagagens ou mercadorias sujeitas a inspecção e de demais actividades ilegais cometidas pelo titular da autorização ou pelos condutores designados.</li>" +
    "  <li>O requerente e o titular da autorização têm de garantir a veracidade dos dados submetidos, caso contrário o pedido será recusado ou a autorização poderá ser cancelada.</li>" +
    "  <li>A permanência do veículo autorizado em Macau fora do prazo, sem justa causa, implica a impedimento de marcação prévia 30 dias após a data de saída de Macau ou a data de confirmação da infracção, pelo período de 15 dias.</li>" +
    "  <li>Em caso de circulação em área proibida, infracção das regras de circulação ou por condução de condutor alheio à autorização, poderá ser cancelada a autorização.</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  2. Protecção dos dados pessoais" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>A Direcção dos Serviços para os Assuntos de Tráfego (adiante designada por DSAT) enquanto Serviço que coordena e assegura o website, garante o cumprimento das respectivas normas por parte dos seus trabalhadores. O tratamento dos dados pessoais está sujeito a medidas de sigilo, sendo devidamente guardados até perderem a utilidade de recolha ou até ao termo do prazo de reserva estabelecido legalmente pelo Governo, altura em que os dados serão destruídos conforme o estipulado.</li>" +
    "  <li>Os dados pessoais inseridos neste website podem ser consultados ou alterados quando solicitados por si à DSAT ou a outros Serviços que procederam à recolha e preservação dos dados.</li>" +
    "  <li>Todos os dados pessoais apresentados pelo requerente serão tratados em conformidade com a Lei n.º 8/2005 (Lei da Protecção de Dados Pessoais) da Região Administrativa Especial de Macau. Caso esta Direcção de Serviços encontre dúvidas durante a apreciação de documentos, as informações podem ser remetidas às entidades competentes para verificação ou consulta. O requerente goza, nos termos da lei, dos direitos de informação, acesso, rectificação e oposição, devendo, no exercício desses direitos, apresentá-los, por escrito, a esta Direcção de Serviços. Antes de apresentar quaisquer dados pessoais a esta Direcção de Serviços, o requerente deve obter o consentimento do titular dos dados e prestar-lhe as informações previstas no n.º 1 do artigo 10.º da Lei n.º 8/2005 (Lei da Protecção de Dados Pessoais).</li>" +
    "  <li>Os dados pessoais inseridos neste website podem ser consultados ou alterados quando solicitados por si à DSAT ou a outros Serviços que procederam à recolha e preservação dos dados. Para efeitos de tratamento do requerimento, a DSAT e as autoridades administrativas relacionadas (incluindo as do Interior da China, Hong Kong e Macau) podem, nos termos da Lei n.º 8/2005 (Lei da Protecção de Dados Pessoais), prestar, trocar, confirmar e utilizar os dados pessoais relativos aos veículos dos interessados, proprietários de veículos e condutores.</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  3. Termos de responsabilidade" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>A presente página electrónica procura assegurar a exactidão do conteúdo, não dando, porém, quaisquer garantias ou compromissos, explícitos ou implícitos. As informações nela contidas são fornecidas conforme “a actualidade”. A DSAT tem direito para eliminar, em qualquer momento, as informações do presente website sem aviso prévio, bem como suspendê-las provisoriamente ou proceder a sua compilação. A DSAT não assumirá qualquer responsabilidade nem compensação a quaisquer danos ou perdas, resultantes das informações do presente website.</li>" +
    "  <li>O presente website irá actualizar, em tempo oportuno, o regulamento de utilização para optimizar a supervisão e o funcionamento deste sistema. Para assegurar que as informações obtidas são oportunas, queira prestar atenção ao anúncio mais recente deste website.</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  4. Cláusulas de privacidade" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>Os dados pessoais inseridos pelo requerente no presente sistema serão exclusivos ao uso do sistema e imprimidos no talão electrónico, caso exista.</li>" +
    "  <li>A DSAT utiliza a “Secure Sockets Layer (SSL)” para garantir a confidencialidade dos dados pessoais dos utentes introduzidos na nossa página electrónica.</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  5. Alteração dos termos de utilização" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>Caso existam actualizações a estes termos de utilização, uma nova versão da política de privacidade será publicada no lugar da antiga, não carecendo de mais qualquer anúncio. A data de revisão estará devidamente assinalada na versão revista.</li>" +
    "</ul>" +
    "<p></p>" +
    "<p>" +
    "  6. Forma de contacto" +
    "  <br />" +
    "</p>" +
    "<ul>" +
    "  <li>Endereço: Área de atendimento da DSAT (Estrada de D. Maria II), sita na Estrada de D. Maria II, n.º 33, Macau</li>" +
    "  <li>Horário de expediente: de segunda a sexta-feira, das 9h às 18h (aberto durante a hora de almoço)</li>" +
    "  <li>Linha aberta para os Assuntos de Tráfego: (853) 8866 6363</li>" +
    "  <li>Correio electrónico: info@dsat.gov.mo</li>" +
    "</ul>",
    terms_hzmbG_cancel:
      "<ul>" +
      "  <li>進入【香港貨車-停泊澳門跨境貨物轉運站】模塊，點擊【取消】模塊，勾選同意使用規章，便可進入服務頁面。</li>" +
      "  <li>輸入身份驗證信息，可通過澳門批准編號或香港車輛登記號碼驗證；選擇登記類型，可選擇以個人作登記或以公司/單位作登記；輸入本澳流動電話，獲取並輸入驗證碼後，便可提交驗證。</li>" +
      "  <li>驗證通過後便可進入信息確認頁面，申請信息中顯示顯示車輛的澳門批准編號、香港車輛登記號碼、車身底盤號碼及流動電話，不可編輯。</li>" +
      "  <li>輸入取消原因，並勾選注意事項，點擊“確認提交”便可提交申請。</li>" +
      "</ul>",
    Vcode: {
      title: "Verificação da segurança",
      successText: "Autenticação aprovada",
      failText: "Falha na autenticação, tente novamente",
      sliderText: "Arraste o controle deslizante para concluir o mosaico gráfico",
      success: "Autenticação aprovada",
    },
  },
  hzmbGInsurance: {
    label: {
      noticePhone: "N.º de telemóvel (para notificação por SMS)",
      admittanceStartDate: "Data inicial da entrada permitida em Macau",
      admittanceEndDate: "Data do termo da entrada permitida em Macau",
      registrationType: "Tipo de veículo de Hong Kong",
      identificationNo: "N.º do quadro de Hong Kong",
      mainlandInsuranceNo: "N.º da apólice",
      mainlandInsuranceStartDate: "Data de vigência da apólice",
      mainlandInsuranceEndDate: "Data do termo da apólice",
    },
    title: {
      boxTitle1: "Dados sobre seguro de Macau",
    },
    message: {
      noChinese: "Preenche apenas letras, números e caracteres",
    },
  },
};
